import Vue from "vue";
import App from "./App.vue";
import { VueMdi, library } from "vue-mdi";
import { mdiDelete, mdiPlus, mdiReload } from "@mdi/js";
import "vue-mdi/dist/mdi.css";

library.add({ mdiDelete, mdiPlus, mdiReload });
Vue.component("vue-mdi", VueMdi);

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
